module.exports = __webpack_public_path__ + "static/media/takePhoto.814ed68f.svg";